{
  "actionbar.actions": "Radnje",
  "actionbar.actionsAvailable": "Dostupne radnje.",
  "actionbar.clearSelection": "Poništi odabir",
  "actionbar.selected": "Odabrano: { count }",
  "actionbar.selectedAll": "Sve je odabrano",
  "button.pending": "u tijeku",
  "calendar.invalidSelection": "{selectedCount, plural, one {Odabrani datum nije dostupan} other {Odabrani datumi nisu dostupni}}.",
  "contextualhelp.help": "Pomoć",
  "contextualhelp.info": "Informacije",
  "datepicker.endTime": "Vrijeme završetka",
  "datepicker.startTime": "Vrijeme početka",
  "datepicker.time": "Vrijeme",
  "dialog.alert": "Upozorenje",
  "dialog.dismiss": "Odbaci",
  "dropzone.replaceMessage": "Ispustite datoteku za zamjenu",
  "inlinealert.informative": "Informacije",
  "inlinealert.negative": "Pogreška",
  "inlinealert.notice": "Upozorenje",
  "inlinealert.positive": "Uspješno",
  "label.(optional)": "(opcionalno)",
  "label.(required)": "(obvezno)",
  "menu.moreActions": "Dodatne radnje",
  "picker.placeholder": "Odaberite…",
  "slider.maximum": "Najviše",
  "slider.minimum": "Najmanje",
  "table.loading": "Učitavam...",
  "table.loadingMore": "Učitavam još...",
  "table.resizeColumn": "Promijeni veličinu stupca",
  "table.sortAscending": "Sortiraj uzlazno",
  "table.sortDescending": "Sortiraj silazno",
  "tag.actions": "Radnje",
  "tag.hideButtonLabel": "Prikaži manje",
  "tag.noTags": "Nema",
  "tag.showAllButtonLabel": "Prikaži sve ({tagCount, number})",
  "breadcrumbs.more": "Više stavki",
  "combobox.noResults": "Nema rezultata",
  "notificationbadge.indicatorOnly": "Nova aktivnost",
  "notificationbadge.plus": "{notifications}+",
  "toast.clearAll": "Clear all",
  "toast.collapse": "Collapse",
  "toast.showAll": "Show all"
}